import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  img: {
    height: 50,
    width: 50,
    borderRadius: theme.spacing(1),
    objectFit: 'cover',
  },
}));

const ImageThumbnail = ({ src, alt, className }) => {
  const classes = useStyles();
  return (
    <img
      className={clsx(classes.img, className)}
      src={src}
      alt={alt}
    />
  );
};

ImageThumbnail.propTypes = {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,

  className: PropTypes.string,
};

ImageThumbnail.defaultProps = {
  className: undefined,
};

export default ImageThumbnail;
